<template>
  <div>
    <div class="alert alert-info">
      Kolom isian dengan tanda bintang (<span style="color: red">*</span>) adalah wajib untuk di isi. <strong>{{messages}}</strong>
    </div>
    <center>
      <pulse-loader style="margin: 15px" :loading="loading" color="#696969" size="10px"></pulse-loader>
    </center>
    <form class="form-horizontal form-space" onsubmit="return false">
      <div v-show="isExist('RIWAYAT')" class="form-group">
        <label class="col-md-3">Riwayat Penyakit</label>
        <div class="col-md-6">
          <input
            type="text"
            name="riwayat"
            placeholder="Riwayat Penyakit"
            class="form-control"
            maxlength="255"
            v-model="model.riwayat"
          >
        </div>
      </div>
      <div v-show="isExist('FISIK')" class="form-group">
        <label class="col-md-3">Keterangan Fisik</label>
        <div class="col-md-4">
          <select
            type="text"
            name="fisik"
            class="form-control"
            v-model="model.fisik"
          >
            <option :value="false">Normal</option>
            <option :value="true">Berkebutuhan Khusus</option>
          </select>
        </div>
      </div>
      <div v-if="model.fisik" :class="{'form-group': true, 'has-error': errors.has('kemampuan_berbeda')}">
        <label class="col-md-3"><span class="required-label">*</span>Kebutuhan Khusus</label>
        <div class="col-md-6">
          <div v-for="kesehatan in options.kesehatan" :key="kesehatan.id_kesehatan">
            <input type="checkbox"
              name="kemampuan_berbeda"
              :id="`checkboxitem${kesehatan.id_kesehatan}`"
              :value="kesehatan.id_kesehatan"
              v-model="model.kemampuan_berbeda"
              v-validate="'required'">
            <label :for="`checkboxitem${kesehatan.id_kesehatan}`">{{ kesehatan.kondisi_kesehatan }}</label>
          </div>
          <span v-show="errors.has('kemampuan_berbeda')" class="error-label">Pilih Kebutuhan Khusus</span>
        </div>
      </div>
      <div v-if="model.fisik" :class="{'form-group': true, 'has-error': errors.has('pendampingan_khusus')}">
        <label class="col-md-3">Pendampingan Khusus</label>
        <div class="col-md-6">
          <input
            type="text"
            name="pendampingan_khusus"
            placeholder="Memerlukan 1 orang khusus untuk mendampingi menjawab soal"
            class="form-control"
            maxlength="100"
            v-model="model.pendampingan_khusus">
        </div>
      </div>
    </form>
    <center>
      <pulse-loader style="margin: 15px" :loading="sending" color="#696969" size="10px"></pulse-loader>
    </center>
  </div>
</template>

<script>
import api from '@/api'
import Options from '@/helper/options'

export default {
  data () {
    return {
      init: false,
      loading: false,
      sending: false,
      model: {
        riwayat: null,
        fisik: false,
        pendampingan_khusus: null,
        kemampuan_berbeda: []
      },
      savedModel: null,
      options: {
        kesehatan: []
      }
    }
  },
  computed: {
    nomorPendaftar () {
      return this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar
    },
    messages () {
      let message = ''
      this.$store.getters.getMessages(7).forEach(item => {
        message = message + ' ' + item.note + '.'
      })
      return message
    }
  },
  methods: {
    validate () {
      return new Promise((resolve, reject) => {
        this.validateForm()
          .then(valid => {
            this.sendData()
              .then(success => {
                if (success) {
                  resolve(true)
                } else {
                  this.flash('gagal menyimpan data', 'error')
                  scroll(0, 0)
                  resolve(false)
                }
              })
          })
          .catch(e => {
            this.flash(e.message, 'error')
            scroll(0, 0)
            resolve(false)
          })
      })
    },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll()
          .then(valid => {
            if (valid) {
              resolve(true)
            } else {
              reject({message: 'isian belum lengkap'})
            }
          })
      })
    },
    isExist (name) {
      return this.$store.getters.formIsExist(name, 7)
    },
    async initData () {
      if (!this.init) {
        this.options.kesehatan = await Options.getOptionsKesehatan()
        this.getDataKesehatan()
        this.getDataKemampuanBerbeda()
        this.init = true
      }
    },
    getDataKesehatan () {
      this.loading = true
      api.get('/v1/kesehatan_mahasiswa/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.model.riwayat = responseData.data.riwayat_penyakit
          }
          this.loading = false
        })
        .catch(e => {
          this.loading = false
        })
    },
    getDataKemampuanBerbeda () {
      api.get('/v2/kemampuan_berbeda/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.model.fisik = true
            responseData.data.forEach(element => {
              this.model.kemampuan_berbeda.push(element.id_kesehatan)
            })
          }
        })
        .catch(e => {
        })
    },
    sendData () {
      return new Promise((resolve, reject) => {
        this.sending = true
        if (!this.model.fisik) {
          this.model.kemampuan_berbeda = []
        }
        let dataKesehatanSender = Promise.resolve(this.sendDataKesehatan())
        let dataKemampuanBerbedaSender = Promise.resolve(this.sendDataKemampuanBerbeda())
        Promise.all([dataKesehatanSender, dataKemampuanBerbedaSender]).then((success) => {
          this.sending = false
          success[0] && success[1] ? resolve(true) : resolve(false)
        })
      })
    },
    sendDataKesehatan () {
      return new Promise((resolve, reject) => {
        if (process.env.NODE_ENV !== 'test') {
          const model = JSON.stringify(this.model)
          if (model !== this.savedModel) {
            api.post('/v2/kesehatan_mahasiswa', {
              nomor_pendaftar: this.nomorPendaftar,
              riwayat_penyakit: this.model.riwayat,
              pendampingan_khusus: this.model.pendampingan_khusus
            })
              .then(response => {
                this.savedModel = model
                resolve(true)
              })
              .catch(e => {
                resolve(false)
              })
          } else {
            resolve(true)
          }
        } else {
          resolve(true)
        }
      })
    },
    sendDataKemampuanBerbeda () {
      return new Promise((resolve, reject) => {
        if (process.env.NODE_ENV !== 'test') {
          const model = JSON.stringify(this.model)
          if (model !== this.savedModel) {
            api.post('/v2/kemampuan_berbeda/many', {
              nomor_pendaftar: this.nomorPendaftar,
              kemampuan_berbeda: this.model.kemampuan_berbeda
            })
              .then(response => {
                this.savedModel = model
                resolve(true)
                if (this.model.fisik) {
                  this.$store.dispatch('setDisability')
                } else {
                  this.$store.dispatch('unsetDisability')
                }
              })
              .catch(e => {
                resolve(false)
              })
          } else {
            resolve(true)
          }
        } else {
          resolve(true)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/register/DataKesehatan.vue